import React, { useEffect, useContext, useState, useRef } from 'react'

import { useNavigate } from 'react-router-dom';

import {
  Box,
} from '@material-ui/core';

import APIS from "../../../../utils/APIS"


import SuperAdminContext from "../../../../contexts/SuperAdminContext"

import { PlusCircle as PlusCircleIcon } from 'react-feather';
import { XCircle as XCircleIcon } from 'react-feather';

import { adminInputStyle } from "../adminStyles.js"

const EcoleForm = ({ isEdit, ecole, setHasChanged }) => {
  const navigate = useNavigate()

  const { updateAdminEcoles } = useContext(SuperAdminContext)

  const [name, setName] = useState("");
  const [groupes, setGroupes] = useState([])
  const [selectedGroupe, setSelectedGroupe] = useState("")

  const [campus, setCampus] = useState([])
  const [newCampusName, setNewCampusName] = useState("")

  const [allGroupes, setAllGroupes] = useState([])

  const [editInitial, setEditInitial] = useState(null)
  const [editLoaded, setEditLoaded] = useState(false)

  const [optionHtml, setOptionHtml] = useState(null)
  const [disableAdd, setDisableAdd] = useState(true)

  useEffect(() => {
    //console.log("au chargement on va chercher tous les groupes même archivés")
    let vals = {archived : true}
    setNewCampusName("")
    APIS.getSuperAdminGroupes({archived:true}).then((results) => {
      setAllGroupes(results)
    })
  }, [])

  const initFct = () => {
    if (isEdit && ecole && allGroupes.length > 0) {
      setName(ecole?.name)
      setGroupes(ecole?.groupes)
      setCampus(ecole?.campus)
      setEditInitial(ecole)

      setEditLoaded(true)
    }
  }

  useEffect(() => {
    initFct()
  }, [isEdit, ecole, allGroupes, editLoaded])

  useEffect(() => {
    if (isEdit === true && editLoaded === true) {
      if (
        name !== editInitial?.name
        || JSON.stringify(groupes) !== JSON.stringify(editInitial?.groupes)
      ) {
        setHasChanged(true)
      } else {
        setHasChanged(false)
      }
    }
    if (isEdit !== true) {
      if (name !== "" && groupes?.length > 0) {
        setHasChanged(true)
      } else {
        setHasChanged(false)
      }
    }
  }, [isEdit, name, groupes, editInitial, editLoaded])

  useEffect(() => {
    if (allGroupes.length > 0) {
      let count = 0;
      setOptionHtml(allGroupes.filter((g) => g.archived !== "true").map((groupe, index) => {
        let find = groupes.find((el) => el.groupeID === groupe.id)
        if (!find) {
          if (count === 0) {
            setSelectedGroupe(groupe.id)
          }
          count++
          return (
            <option key={index + 'groupeSelect'} value={groupe.id}>
              {groupe.name}
            </option>
          )
        }
      }))
      if (count === 0) {
        setDisableAdd(true)
      } else {
        setDisableAdd(false)
      }
    }
  }, [allGroupes, editLoaded, editInitial, groupes])

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setHasChanged(false)
    if (isEdit) {
      //removedGroupes
      let removedGroupes = editInitial?.groupes?.filter((el) => {
        return !groupes.find((g) => g.groupeID === el.groupeID)
      })
      //addedGroupes
      let addedGroupes = groupes.filter((el) => {
        return !editInitial?.groupes?.find((g) => g.groupeID === el.groupeID)
      })
      let values = {id : parseInt(ecole?.id), name : name, removedGroupes : removedGroupes, addedGroupes : addedGroupes}
      APIS.editEcole(values).then((result) => {
        if (result?.isOk === true) {
          updateAdminEcoles()
        } else {
          alert("Erreur !")
          setHasChanged(true)
        }
      })
    } else {
      //pour création
      if (name !== "" && groupes?.length > 0) {
        let values = {name : name, groupes : groupes}
        APIS.addEcole(values).then((result) => {
          if (result?.isOk === true) {
            updateAdminEcoles()
            navigate('/admin/ecoles')
          } else {
            alert("Erreur !")
            setHasChanged(true)
          }
        })
      } else {
        alert ("Il y a un problème avec les informations renseignées")
      }
    }
  }


  return (
    <>
      <form noValidate onSubmit={onSubmitForm}>
        <Box sx={{ padding:"0px 10px" }}>
          <Box>
            <Box>Nom</Box>
            <input
              onChange={(e) => {setName(e.target.value)}}
              value={name}
              id="name"
              name="name"
              placeholder="Nawal Abboub"
              type="text"
              style={adminInputStyle}
            />
          </Box>

          <Box sx={{marginTop:'15px'}}>
            <Box>Groupe(s) actuels</Box>
            <Box sx={{marginLeft:'5px'}}>
              {allGroupes && groupes && groupes.map((groupe, index) => {
                let find = allGroupes.find((el) => el.id === groupe.groupeID)
                if (find) {
                  return (
                    <Box key={"actGroupe"+find.id} sx={{display:"flex", alignItems:"center"}}>
                      {find.archived === "true" ? (
                        <p>- {find.name} (archivé)</p>
                      ) : (
                        <p>- {find.name}</p>
                      )}
                      <XCircleIcon
                        color="black"
                        size={14}
                        style={{marginLeft:"10px", cursor:"pointer"}}
                        onClick={() => {
                          setGroupes(
                            groupes.filter(el =>
                              el.groupeID !== find.id
                            )
                          );
                        }}
                      />
                    </Box>
                  )
                }
              })}
            </Box>
          </Box>

          <Box sx={{marginTop:'15px'}}>
            <Box>Ajouter groupe</Box>
            <Box sx={{marginTop:'10px', display:'flex', marginLeft:'5px'}}>
              <select
                onChange={(e) => { setSelectedGroupe(e.target.value) }}
                id="groupes"
                name="groupes"
                style={{width:'307px'}}
                value={selectedGroupe}
                disabled={disableAdd}
              >
                {optionHtml}
              </select>
              <PlusCircleIcon
                color="black"
                size={19}
                style={{marginLeft:"15px", cursor:"pointer", opacity: disableAdd === true ? 0.4 : 1}}
                onClick={() => {
                  if (disableAdd !== true) {
                    setGroupes([...groupes, {groupeID : parseInt(selectedGroupe)}])
                  }
                }}
              />
            </Box>
          </Box>

          {isEdit !== false &&
            <>
              <Box style={{
                marginTop:"40px",
                marginBottom:"40px",
                borderTop:"1px dashed black"
              }} />
              <Box style={{marginTop:'15px'}}>
                <Box>Campus actuels</Box>
                <Box style={{marginLeft:'5px'}}>
                  {campus.length === 0 &&
                    <p style={{fontStyle:"italic", opacity:0.7}}>Pas de campus</p>
                  }
                  {campus.length > 0 && campus.map((campus, index) => {
                    return (
                      <Box key={"actCampus"+campus.id} sx={{display:"flex", alignItems:"center"}}>
                        <p>- {campus.name} <font style={{fontStyle:"italic", opacity:0.7}}>(id : {campus.id})</font></p>
                        <XCircleIcon
                          color="black"
                          size={14}
                          style={{marginLeft:"10px", cursor:"pointer"}}
                          onClick={() => {
                            let values = {
                              ecoleID : parseInt(ecole?.id),
                              campusID : campus.id
                            }
                            APIS.deleteCampusForEcole(values).then((result) => {
                              if (result?.isOk === true) {
                                updateAdminEcoles()
                              } else if (result?.isOk === "used") {
                                alert("Erreur, ce campus est utilisé par des utilisateurs !")
                              } else {
                                alert("Erreur !")
                              }
                            })
                          }}
                        />
                      </Box>
                    )
                  })}
                </Box>
              </Box>
              <Box sx={{marginTop:'15px'}}>
                <Box>Ajouter campus</Box>
                <Box sx={{marginTop:'5px', display:'flex', marginLeft:'5px'}}>
                  <input
                    type="text"
                    style={{width:'307px', marginTop:0}}
                    placeholder="Nom du campus"
                    value={newCampusName}
                    onChange={(e) => { setNewCampusName(e.target.value) }}
                  />
                  <PlusCircleIcon
                    color="black"
                    size={19}
                    style={{marginLeft:"15px", cursor:"pointer", opacity:newCampusName.length >= 3 ? 1 : 0.5}}
                    onClick={() => {
                      if (newCampusName.length >= 3) {
                        let values = {
                          ecoleID : parseInt(ecole?.id),
                          name : newCampusName
                        }
                        APIS.addCampusForEcole(values).then((result) => {
                          if (result?.isOk === true) {
                            updateAdminEcoles()
                            setNewCampusName("")
                          } else {
                            alert("Erreur !")
                          }
                        })
                      }
                    }}
                  />
                </Box>
              </Box>
            </>
          }


          <button hidden type="submit" id="hidden_form_submit">
            Action
          </button>
        </Box>
      </form>
    </>
  )
};

export default EcoleForm;
